import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { AppBar, Toolbar } from '@material-ui/core';
const useStyles = makeStyles((theme) => ({
  root: {
    boxShadow: 'none',
    [theme.breakpoints.down('md')]: {
      height : 0
    },
  }
}));

export const Topbar = (props) => {
  const classes = useStyles();
  return (
    <AppBar 
      {...props}
      className={classes.root}
      color="primary"
      position="fixed"
    >
      <Toolbar>
        <RouterLink to="/">
        </RouterLink>
      </Toolbar>
    </AppBar>
  );
};
